import YouTubeProvider from './media-providers/YouTubeProvider'
import VimeoProvider from './media-providers/VimeoProvider'
import SoundCloudProvider from './media-providers/SoundCloudProvider'

export default {
    init(media) {
        return this[media.provider].init(media)
    },
    'youtube': {
        init(media) {
            return new YouTubeProvider(media)
        },
    },
    'vimeo': {
        init(media) {
            return new VimeoProvider(media)
        },
    },
    'soundcloud': {
        init(media) {
            return new SoundCloudProvider(media)
        },
    },
}